import {
  setMemberCellValue,
  type TemplateMemberValueColumn,
  type TemplateMemberValuesMap,
} from '@/core/lib/profile-template-member-values';
import type { MemberRosterRow } from '@/core/lib/profile-template-member-values-csv';

export function memberValuesEntryHasData(
  entry: TemplateMemberValuesMap[string] | undefined,
): boolean {
  if (!entry) return false;
  return (
    entry.jobTitle != null ||
    entry.company != null ||
    entry.location != null ||
    (entry.socials != null && Object.keys(entry.socials).length > 0) ||
    (entry.moduleEntries != null &&
      Object.values(entry.moduleEntries).some((v) => v != null && v !== '')) ||
    (entry.settings != null &&
      Object.values(entry.settings).some((v) => v != null && v !== ''))
  );
}

export function memberMatchesSearch(
  member: MemberRosterRow,
  query: string,
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return (
    member.displayName.toLowerCase().includes(q) ||
    (member.email?.toLowerCase().includes(q) ?? false)
  );
}

export function applyMemberValuesUpdate(
  memberValues: TemplateMemberValuesMap,
  userId: string,
  column: TemplateMemberValueColumn,
  value: string,
  options?: { normalizeWhitespace?: boolean },
): TemplateMemberValuesMap {
  const entry = setMemberCellValue(
    { ...(memberValues[userId] ?? {}) },
    column,
    value,
    options,
  );
  const next = { ...memberValues };
  if (memberValuesEntryHasData(entry)) {
    next[userId] = entry;
  } else {
    delete next[userId];
  }
  return next;
}
